import { defineMessage } from '@redbubble/next/intl';
import ex8FImg from '../assets/models/ex8_f.png';
import ex8MImg from '../assets/models/ex8_m.png';
import { PreQuerySizeGuideData } from '../types';
import {
  extendedInternationalConversions,
  howToChooseSizeTshirtInstructions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 8
 * Oversized t-shirt
 * billowing-parachute
 */

export const experience8: PreQuerySizeGuideData = {
  internationalConversions: extendedInternationalConversions,
  fitIndicator: {
    value: 6 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    male: {
      imageUrl: ex8MImg.src,
      // TBC with product
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Large. He usually wears a size Large.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 188 cm / 6’2”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 53.5 cm / 21”',
        }),
      ],
    },
    female: {
      imageUrl: ex8FImg.src,
      // TBC with product
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Small. She usually wears a size Small.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 160 cm / 5’3”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 43 cm / 17”',
        }),
      ],
    },
  },
};
